export default __webpack_public_path__ + "static/media/DOGE.7d36003d.png";